import React, { type FC, useMemo } from 'react';
import { CartCounterButton } from '../../../core-components/molecules/cart-counter-button';
import styles from '../../../core-components/organisms/cart-item-v2/cart-item-v2.module.css';
import Button from '../../atoms/button';
import { CartItemGroupVariantEnum, cn } from '../../../core-components';
import { type CartCounterSectionProps } from './cart-counter-section.types';

export const CartCounterSection: FC<CartCounterSectionProps> = ({
    item,
    cartItemReference,
    cartCounterButtonProps,
    disabled,
    variantCounterButton,
    variantCartItemGroup,
    onDelete,
    buttonProps,
}) => {
    const isMini = useMemo(() => variantCartItemGroup === CartItemGroupVariantEnum.MINI, [variantCartItemGroup]);
    const cartCounterButtonContainerClass = useMemo(
        () => cn(styles.counterButton, cartCounterButtonProps?.containerStyle, disabled && styles.disabled),
        [cartCounterButtonProps?.containerStyle, disabled]
    );

    if (!cartCounterButtonProps) return null;

    const counter = (
        <CartCounterButton
            item={item}
            cartItemReference={cartItemReference}
            {...cartCounterButtonProps}
            disabled={disabled ?? false}
            variant={variantCounterButton}
            containerStyle={cartCounterButtonContainerClass}
        />
    );

    if (!isMini) {
        return counter;
    }

    return (
        <div className={styles.counterContainer}>
            {counter}

            <Button {...buttonProps} onClick={onDelete} className={cn(styles.miniDelete, buttonProps?.className)} />
        </div>
    );
};
